import { Component, DestroyRef, inject, input, output, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InventoryActionDetailsComponent } from '../inventory-action-details.component';
import { InventoryAction } from '../../../../models/inventory_action.model';
import { toUnderscore } from '../../../../utils/string-utils';
import { AdminService } from '../../../../admin/services/admin.service';
import { ProviderService } from '../../../../providers/provider.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { RoleService } from '../../../../role/role.service';
import { BuyOrderEditFormComponent } from '../../form/edit/buy-order-form/buy-order-edit-form.component';
import { ChatService } from '../../../../chat/chat.service';

@Component({
    selector: 'app-inventory-action-for-buy-order-details',
    templateUrl: './inventory-action-for-buy-order-details.component.html',
    styleUrls: [
        './inventory-action-for-buy-order-details.component.scss',
        '../inventory-action-details.component.scss',
    ],
    standalone: false
})
export class InventoryActionForBuyOrderDetailsComponent {

  dialogRef = input<MatDialogRef<InventoryActionDetailsComponent>>();
  
  loading = signal<boolean>(false);

  reloadInventoryAction = input(() => {});

  inventoryAction = input<InventoryAction>();

  public readonly adminService = inject(AdminService);

  private readonly dialog = inject(MatDialog);

  private readonly location = inject(Location);

  private readonly providerService = inject(ProviderService);
  
  private readonly snackBar = inject(MatSnackBar);

  private readonly roleService = inject(RoleService);

  private readonly chatService = inject(ChatService);

  private readonly destroyRef = inject(DestroyRef);

  get canUpdate() {
    return this.roleService.can('inventory_action', 'update');
  }

  get isFinished(): boolean {
    return this.inventoryAction().finish;
  } 

  get isAnswered(): boolean {
    return !this.inventoryAction().draft;
  }

  get title() {
    const action = this.adminService.getText(toUnderscore(this.inventoryAction()?.type));
    return `${action} #${this.inventoryAction()?.correlative_id}`;
  }

  get answeredAt(): Date {
    return this.inventoryAction().extra_params?.answered_at;
  }

  public get IVA() {
    return this.Subtotal * (this.adminService.getTaxValue() - 1);
  }

  public get Total() {
    return this.Subtotal * this.adminService.getTaxValue();
  }

  public get Subtotal() {
    return this.inventoryAction().total;
  }

  sendBuyOrder() {
    this.providerService.sendBuyOrder({ inventory_action_for_buy_order_id: this.inventoryAction().id }).subscribe(() => {
      this.reloadInventoryAction()();
      this.snackBar.open('Orden de Compra enviada', 'Cerrar', { duration: 2000 });
    });
  }
  
  goBack() {
    if (this.dialogRef() instanceof MatDialogRef) {
      this.dialogRef().close();
    } else {
      this.location.back();
    }
  }

  addChat() {
    this.chatService.addChat(this.inventoryAction().type,this.inventoryAction().id).toPromise().then((response) => {});
  }

}
